import Pagination from './Pagination';
export default Pagination;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/pagination/index.js
// module id = 211
// module chunks = 0